// @flow

import type {ApplicationState} from '../../types'
import type {GbiprojectState} from '../types'

export function isLoading(appState: ApplicationState): boolean {
  return _isLoading(appState.gbiProject)
}

function _isLoading(state: GbiprojectState): boolean {
  return state.isLoading
}

isLoading.internal = _isLoading
